import { ANALYZE, ARTIFICIAL_INTELLIGENCE, ASSESSMENTS, BUSINESSES, CONTROLS, DOCUMENTS, FRAMEWORKS, GENERATE, GROUPS, OPERATIONAL_CONTROLS, REVIEW, SERVICES, THIRD_PARTIES, TPRM, UCRM, USE_CASES } from 'Config/Paths';
import { AiContentAdvisorRequest, AiContentAdvisorResponse, AiDocAnalysis, AiDocAnalyzerCreateRequest, AiDocGeneratorCreateRequest, AiDueDiligenceAnalyzeAssessmentRequest, AiGeneratedDoc, AiOperationalControlAssessment } from 'Models/ArtificialIntelligence';
import { ResponseModel } from 'Models/ResponseModel';
import { ThirdPartyService, TprmDueDiligenceAssessment } from 'Models/TPRM';
import { UcrmDueDiligenceAssessment, UseCase } from 'Models/Ucrm';
import { restApiDelete, restApiGet, restApiPost } from 'RestApiConnector';

import { ArtificialIntelligenceApi } from './ArtificialIntelligenceApi';

export class AWSArtificialIntelligenceApi implements ArtificialIntelligenceApi {
    // AI - Content Advisor.
    aiContentAdvisorCreate = (request: AiContentAdvisorRequest): Promise<ResponseModel<AiContentAdvisorResponse>> => {
        return restApiPost(`/${ARTIFICIAL_INTELLIGENCE}/${REVIEW}`, request);
    };

    // AI - Document Analyzer.
    aiDocAnalyzerCreate = (request: AiDocAnalyzerCreateRequest): Promise<ResponseModel<AiDocAnalysis>> => {
        return restApiPost(`/${ARTIFICIAL_INTELLIGENCE}/${DOCUMENTS}/${ANALYZE}`, request);
    };
    aiDocAnalyzerDelete = (aiDocAnalysis: AiDocAnalysis): Promise<ResponseModel<void>> => {
        return restApiDelete(`/${ARTIFICIAL_INTELLIGENCE}/${DOCUMENTS}/${ANALYZE}/${aiDocAnalysis.id}`);
    };
    aiDocAnalyzerGet = (aiDocAnalysisId: string): Promise<ResponseModel<AiDocAnalysis>> => {
        return restApiGet(`/${ARTIFICIAL_INTELLIGENCE}/${DOCUMENTS}/${ANALYZE}/${aiDocAnalysisId}`);
    };
    aiDocAnalyzerGetAll = (): Promise<ResponseModel<AiDocAnalysis[]>> => {
        return restApiGet(`/${ARTIFICIAL_INTELLIGENCE}/${DOCUMENTS}/${ANALYZE}`);
    };

    // AI - Document Generator.
    aiDocGeneratorCreate = (request: AiDocGeneratorCreateRequest): Promise<ResponseModel<void>> => {
        return restApiPost(`/${ARTIFICIAL_INTELLIGENCE}/${DOCUMENTS}/${GENERATE}`, request);
    };
    aiDocGeneratorDelete = (aiGeneratedDoc: AiGeneratedDoc): Promise<ResponseModel<void>> => {
        return restApiDelete(`/${ARTIFICIAL_INTELLIGENCE}/${DOCUMENTS}/${GENERATE}/${aiGeneratedDoc.id}`);
    };
    aiDocGeneratorGetAll = (): Promise<ResponseModel<AiGeneratedDoc[]>> => {
        return restApiGet(`/${ARTIFICIAL_INTELLIGENCE}/${DOCUMENTS}/${GENERATE}`);
    };

    // AI - Operational Controls.
    aiOperationalControlsCreate = (control_framework: string, control_group_id: string, control_id: string): Promise<ResponseModel<void>> => {
        return restApiPost(`${ARTIFICIAL_INTELLIGENCE}/${OPERATIONAL_CONTROLS}/${FRAMEWORKS}/${control_framework}/${GROUPS}/${control_group_id}/${CONTROLS}/${control_id}`, {});
    };

    aiOperationalControlsGet = (control_framework: string, control_group_id: string, control_id: string): Promise<ResponseModel<AiOperationalControlAssessment>> => {
        return restApiGet(`${ARTIFICIAL_INTELLIGENCE}/${OPERATIONAL_CONTROLS}/${FRAMEWORKS}/${control_framework}/${GROUPS}/${control_group_id}/${CONTROLS}/${control_id}`, {});
    };

    aiOperationalControlsDelete = (control_framework: string, control_group_id: string, control_id: string): Promise<ResponseModel<void>> => {
        return restApiDelete(`${ARTIFICIAL_INTELLIGENCE}/${OPERATIONAL_CONTROLS}/${FRAMEWORKS}/${control_framework}/${GROUPS}/${control_group_id}/${CONTROLS}/${control_id}`);
    };

    // AI - TPRM.
    aiTprmServiceAssessmentStart = (request: AiDueDiligenceAnalyzeAssessmentRequest, thirdPartyId: string, thirdPartyServiceId: string, assessmentId: string): Promise<ResponseModel<TprmDueDiligenceAssessment>> => {
        return restApiPost(`/${ARTIFICIAL_INTELLIGENCE}/${TPRM}/${THIRD_PARTIES}/${thirdPartyId}/${SERVICES}/${thirdPartyServiceId}/${ASSESSMENTS}/${assessmentId}`, request);
    };

    aiTprmFinalReviewStart = (thirdPartyId: string, thirdPartyServiceId: string): Promise<ResponseModel<ThirdPartyService>> => {
        return restApiPost(`/${ARTIFICIAL_INTELLIGENCE}/${TPRM}/${THIRD_PARTIES}/${thirdPartyId}/${SERVICES}/${thirdPartyServiceId}/${REVIEW}`, {});
    };

    // AI - UCRM.
    aiUcrmUseCaseAssessmentStart = (request: AiDueDiligenceAnalyzeAssessmentRequest, businessId: string, useCaseId: string, assessmentId: string): Promise<ResponseModel<UcrmDueDiligenceAssessment>> => {
        return restApiPost(`/${ARTIFICIAL_INTELLIGENCE}/${UCRM}/${BUSINESSES}/${businessId}/${USE_CASES}/${useCaseId}/${ASSESSMENTS}/${assessmentId}`, request);
    };

    aiUcrmFinalReviewStart = (businessId: string, useCaseId: string): Promise<ResponseModel<UseCase>> => {
        return restApiPost(`/${ARTIFICIAL_INTELLIGENCE}/${UCRM}/${BUSINESSES}/${businessId}/${USE_CASES}/${useCaseId}/${REVIEW}`, {});
    };
}
